module.exports = __webpack_public_path__ + "42f7c1017354f3f5bb7208e1b1e4d417.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Digi/digi.png
// module id = 1424
// module chunks = 13